import { getPublicUrl } from '../appconfig';

export const article_faq = {
  187389: [
    {
      questionName: 'What is a Good Weight for a Baby?',
      acceptedAnswerText:
        'The average weight at birth of an Indian baby is between 2.7 to 3.2 kgs. As babies grow, this average changes as per the baby weight chart above.',
    },
    {
      questionName: 'What Affects Baby Weight?',
      acceptedAnswerText:
        'Factors such as pregnancy term and health, health conditions, sleep and hormones can affect baby weight.',
    },
    {
      questionName:
        "What if Your Baby's Height and Weight do not Fall Within the Percentile Range?",
      acceptedAnswerText:
        'It’s normal for a baby’s height and weight to not fall within the percentile range. Each baby is different and grows at their unique pace.',
    },
    {
      questionName: 'How Much Weight Should a Baby Gain Each Month?',
      acceptedAnswerText:
        'Babies experience growth spurts according to which they may lose or gain weight. A normal baby should gain somewhere between 400 grams to 1 kg weight each month in the first year.',
    },
    {
      questionName: 'Will Eating More Help my Baby Gain Weight?',
      acceptedAnswerText:
        'If your baby is underweight, you may add healthy foods to their diet to accelerate weight gain.',
    },
    {
      questionName: 'What are the Reasons for Baby not Gaining Weight?',
      acceptedAnswerText:
        'Some possible reasons for your baby not gaining weight could be hormonal imbalance, prolonged use of certain medications or chronic illnesses.',
    },
    {
      questionName: 'Is the Same Growth Chart Applicable for Premature Babies?',
      acceptedAnswerText:
        'Yes, the same baby’s weight chart is applicable to premature babies. However, for babies born before their term, month 0 is considered the date of a full-term pregnancy.',
    },
  ],
};

export const hrefMap = {
  37198: {
    hrefLang: 'hi',
    href: `${getPublicUrl()}/te/article/peeing-after-sex-in-hindi-%E0%A4%95%E0%A5%8D%E0%A4%AF%E0%A4%BE-%E0%A4%B8%E0%A5%87%E0%A4%95%E0%A5%8D%E0%A4%B8-%E0%A4%95%E0%A5%87-%E0%A4%A4%E0%A5%81%E0%A4%B0%E0%A4%82%E0%A4%A4-%E0%A4%AC%E0%A4%BE%E0%A4%A6-%E0%A4%AF%E0%A5%82%E0%A4%B0%E0%A4%BF%E0%A4%A8-%E0%A4%AA%E0%A4%BE%E0%A4%B8-%E0%A4%95%E0%A4%B0%E0%A4%A8%E0%A4%BE-%E0%A4%9C%E0%A4%BC%E0%A4%B0%E0%A5%82%E0%A4%B0%E0%A5%80-%E0%A4%B9%E0%A5%8B%E0%A4%A4%E0%A4%BE-%E0%A4%B9%E0%A5%88-37198`,
  },
  226555: {
    hrefLang: 'en',
    href: `${getPublicUrl()}/article/should-i-pee-after-sex-if-trying-to-get-pregnant-and-5-other-faqs-226555`,
  },
  215037: { hrefLang: 'ta', href: `${getPublicUrl()}/ta/article/-215037` },
  168722: {
    hrefLang: 'bn',
    href: `${getPublicUrl()}/bn/article/%E0%A6%AE%E0%A6%BE%E0%A6%B8%E0%A6%BF%E0%A6%95-%E0%A6%AC%E0%A6%A8%E0%A7%8D%E0%A6%A7-%E0%A6%B9%E0%A6%93%E0%A7%9F%E0%A6%BE%E0%A6%B0-%E0%A6%AA%E0%A6%B0%E0%A7%87-%E0%A6%95%E0%A7%80%E0%A6%AD%E0%A6%BE%E0%A6%AC%E0%A7%87-%E0%A6%AA%E0%A7%8D%E0%A6%B0%E0%A6%BE%E0%A6%95%E0%A7%83%E0%A6%A4%E0%A6%BF%E0%A6%95-%E0%A6%89%E0%A6%AA%E0%A6%BE%E0%A7%9F%E0%A7%87-%E0%A6%97%E0%A6%B0%E0%A7%8D%E0%A6%AD%E0%A6%A7%E0%A6%BE%E0%A6%B0%E0%A6%A3-%E0%A6%8F%E0%A6%A1%E0%A6%BC%E0%A6%BE%E0%A6%A8%E0%A7%8B-%E0%A6%AF%E0%A6%BE%E0%A6%AF%E0%A6%BC-168722`,
  },
  163677: {
    hrefLang: 'en',
    href: `${getPublicUrl()}/article/how-to-avoid-pregnancy-naturally-after-missing-period-163677`,
  },
  41181: {
    hrefLang: 'en',
    href: `${getPublicUrl()}/article/foods-that-cause-miscarriage-41181`,
  },

  69300: {
    hrefLang: 'en',
    href: `${getPublicUrl()}/article/government-scheme-to-give-rs-6000-to-pregnant-women-69300`,
  },
  163870: {
    hrefLang: 'en',
    href: `${getPublicUrl()}/article/sex-during-the-first-3-months-of-pregnancy-163870`,
  },
  194540: {
    hrefLang: 'en',
    href: `${getPublicUrl()}/article/crown-rump-length-crl-on-ultrasounds-194540`,
  },

  193737: {
    hrefLang: 'ta',
    href: `${getPublicUrl()}/ta/article/%E0%AE%95%E0%AE%B0%E0%AF%81%E0%AE%9A%E0%AF%8D%E0%AE%9A%E0%AE%BF%E0%AE%A4%E0%AF%88%E0%AE%B5%E0%AF%88-%E0%AE%8F%E0%AE%B1%E0%AF%8D%E0%AE%AA%E0%AE%9F%E0%AF%81%E0%AE%A4%E0%AF%8D%E0%AE%A4%E0%AE%95%E0%AF%8D%E0%AE%95%E0%AF%82%E0%AE%9F%E0%AE%BF%E0%AE%AF-%E0%AE%89%E0%AE%A3%E0%AE%B5%E0%AF%81%E0%AE%95%E0%AE%B3%E0%AF%8D-193737`,
  },
  197483: {
    hrefLang: 'ta',
    href: `${getPublicUrl()}/ta/article/-197483`,
  },
  204663: {
    hrefLang: 'ta',
    href: `${getPublicUrl()}/ta/article/crl-204663`,
  },
  194412: {
    hrefLang: 'ta',
    href: `${getPublicUrl()}/ta/article/%E0%AE%95%E0%AE%B0%E0%AF%8D%E0%AE%AA%E0%AF%8D%E0%AE%AA%E0%AE%A4%E0%AF%8D%E0%AE%A4%E0%AE%BF%E0%AE%A9%E0%AF%8D%20%E0%AE%AE%E0%AF%81%E0%AE%A4%E0%AE%B2%E0%AF%8D%203%20%E0%AE%AE%E0%AE%BE%E0%AE%A4%E0%AE%99%E0%AF%8D%E0%AE%95%E0%AE%B3%E0%AE%BF%E0%AE%B2%E0%AF%8D%20%E0%AE%89%E0%AE%9F%E0%AE%B2%E0%AF%81%E0%AE%B1%E0%AE%B5%E0%AF%81-194412`,
  },
  174306: {
    hrefLang: 'te',
    href: `${getPublicUrl()}/te/article/%E0%B0%AA%E0%B1%8D%E0%B0%B0%E0%B1%86%E0%B0%97%E0%B1%8D%E0%B0%A8%E0%B1%86%E0%B0%A8%E0%B1%8D%E0%B0%B8%E0%B1%80%2520%E0%B0%AF%E0%B1%8A%E0%B0%95%E0%B1%8D%E0%B0%95%2520%E0%B0%AE%E0%B1%8A%E0%B0%A6%E0%B0%9F%E0%B0%BF%25203%2520%E0%B0%A8%E0%B1%86%E0%B0%B2%E0%B0%B2%E0%B1%8D%E0%B0%B2%E0%B1%8B%2520%E0%B0%B8%E0%B1%86%E0%B0%95%E0%B1%8D%E0%B0%B8%E0%B1%8D%25E2%2580%258C%2520%E0%B0%97%E0%B1%81%E0%B0%B0%E0%B0%BF%E0%B0%82%E0%B0%9A%E0%B0%BF%2520%E0%B0%85%E0%B0%B5%E0%B0%97%E0%B0%BE%E0%B0%B9%E0%B0%A8%2520-174306`,
  },
  197481: {
    hrefLang: 'te',
    href: `${getPublicUrl()}/te/article/-197481`,
  },
  205233: {
    hrefLang: 'te',
    href: `${getPublicUrl()}/te/article/%E0%B0%AA%E0%B1%8D%E0%B0%B0%E0%B1%86%E0%B0%97%E0%B1%8D%E0%B0%A8%E0%B1%86%E0%B0%A8%E0%B1%8D%E0%B0%B8%E0%B1%80-%E0%B0%B8%E0%B1%8D%E0%B0%95%E0%B0%BE%E0%B0%A8%E0%B1%8D%E2%80%8C%E0%B0%B2%E0%B1%8B-CRL-205233`,
  },
  159479: {
    hrefLang: 'bn',
    href: `${getPublicUrl()}/bn/article/%E0%A6%AF%E0%A7%87%E0%A6%B8%E0%A6%AC-%E0%A6%96%E0%A6%BE%E0%A6%AC%E0%A6%BE%E0%A6%B0-%E0%A6%97%E0%A6%B0%E0%A7%8D%E0%A6%AD%E0%A6%AA%E0%A6%BE%E0%A6%A4%E0%A7%87%E0%A6%B0-%E0%A6%95%E0%A6%BE%E0%A6%B0%E0%A6%A3-foods-lead-to-miscarriage-in-bengali-159479`,
  },
  168297: {
    hrefLang: 'bn',
    href: `${getPublicUrl()}/bn/article/%E0%A6%97%E0%A6%B0%E0%A7%8D%E0%A6%AD%E0%A6%BE%E0%A6%AC%E0%A6%B8%E0%A7%8D%E0%A6%A5%E0%A6%BE%E0%A6%B0-%E0%A6%AA%E0%A7%8D%E0%A6%B0%E0%A6%A5%E0%A6%AE-3-%E0%A6%AE%E0%A6%BE%E0%A6%B8%E0%A7%87-%E0%A6%AF%E0%A7%8C%E0%A6%A8%E0%A6%AE%E0%A6%BF%E0%A6%B2%E0%A6%A8-sex-during-the-first-3-months-of-pregnancy-in-bengali-168297`,
  },
  195791: {
    hrefLang: 'bn',
    href: `${getPublicUrl()}/bn/article/-%E0%A6%B8%E0%A6%B0%E0%A6%95%E0%A6%BE%E0%A6%B0%E0%A6%BF%20%E0%A6%AA%E0%A6%B0%E0%A6%BF%E0%A6%95%E0%A6%B2%E0%A7%8D%E0%A6%AA%E0%A6%A8%E0%A6%BE%20%E0%A6%85%E0%A6%A8%E0%A7%81%E0%A6%AF%E0%A6%BE%E0%A6%AF%E0%A6%BC%E0%A7%80%20%E0%A6%AA%E0%A7%8D%E0%A6%B0%E0%A6%A4%E0%A7%8D%E0%A6%AF%E0%A7%87%E0%A6%95%20%E0%A6%97%E0%A6%B0%E0%A7%8D%E0%A6%AD%E0%A6%AC%E0%A6%A4%E0%A7%80%20%E0%A6%AE%E0%A6%B9%E0%A6%BF%E0%A6%B2%E0%A6%BE%20%E0%A7%AC%E0%A7%A6%E0%A7%A6%E0%A7%A6%20%E0%A6%9F%E0%A6%BE%E0%A6%95%E0%A6%BE%20%E0%A6%AA%E0%A7%87%E0%A6%A4%E0%A7%87%20%E0%A6%AA%E0%A6%BE%E0%A6%B0%E0%A7%87%E0%A6%A8%20%E0%A6%AA%E0%A7%8D%E0%A6%B0%E0%A6%A7%E0%A6%BE%E0%A6%A8%E0%A6%AE%E0%A6%A8%E0%A7%8D%E0%A6%A4%E0%A7%8D%E0%A6%B0%E0%A7%80%20%E0%A6%AE%E0%A6%BE%E0%A6%A4%E0%A7%8D%E0%A6%B0%E0%A7%81%20%E0%A6%AC%E0%A6%A8%E0%A7%8D%E0%A6%A6%E0%A6%A8%E0%A6%BE%20%E0%A6%AF%E0%A7%8B%E0%A6%9C%E0%A6%A8%E0%A6%BE%20%E0%A6%8F%E0%A6%B0%20%E0%A6%AE%E0%A6%BE%E0%A6%A7%E0%A7%8D%E0%A6%AF%E0%A6%AE%E0%A7%87%E0%A5%A4%20%E0%A6%95%E0%A6%BF%E0%A6%A8%E0%A7%8D%E0%A6%A4%E0%A7%81%20%E0%A6%95%E0%A6%BF%E0%A6%AD%E0%A6%BE%E0%A6%AC%E0%A7%87%20%E0%A6%AA%E0%A6%BE%E0%A6%AC%E0%A7%87%E0%A6%A8%3F%C2%A0-195791`,
  },
  223417: {
    hrefLang: 'bn',
    href: `${getPublicUrl()}/bn/article/%E0%A6%97%E0%A6%B0%E0%A7%8D%E0%A6%AD%E0%A6%BE%E0%A6%AC%E0%A6%B8%E0%A7%8D%E0%A6%A5%E0%A6%BE%E0%A6%B0-%E0%A6%B8%E0%A7%8D%E0%A6%95%E0%A7%8D%E0%A6%AF%E0%A6%BE%E0%A6%A8%E0%A7%87-%E0%A6%B8%E0%A6%BF-%E0%A6%86%E0%A6%B0-%E0%A6%8F%E0%A6%B2-crl-in-pregnancy-scan-in-bengali-223417`,
  },
};

export const articlesHreflangMapping = {
  226555: [hrefMap['37198']],
  37198: [hrefMap['226555']],

  163677: [hrefMap['215037'], hrefMap['168722']],
  215037: [hrefMap['163677'], hrefMap['168722']],
  168722: [hrefMap['163677'], hrefMap['215037']],

  41181: [hrefMap['193737'], hrefMap['159479']],
  193737: [hrefMap['41181'], hrefMap['159479']],
  159479: [hrefMap['193737'], hrefMap['41181']],

  69300: [hrefMap['197483'], hrefMap['197481'], hrefMap['195791']],
  197483: [hrefMap['197481'], hrefMap['195791'], hrefMap['69300']],
  197481: [hrefMap['195791'], hrefMap['69300'], hrefMap['197483']],
  195791: [hrefMap['69300'], hrefMap['197483'], hrefMap['197481']],

  194540: [hrefMap['223417'], hrefMap['205233'], hrefMap['204663']],
  204663: [hrefMap['223417'], hrefMap['205233'], hrefMap['194540']],
  205233: [hrefMap['223417'], hrefMap['194540'], hrefMap['204663']],
  223417: [hrefMap['194540'], hrefMap['205233'], hrefMap['204663']],

  163870: [hrefMap['168297'], hrefMap['174306'], hrefMap['194412']],
  194412: [hrefMap['168297'], hrefMap['174306'], hrefMap['163870']],
  174306: [hrefMap['168297'], hrefMap['163870'], hrefMap['194412']],
  168297: [hrefMap['163870'], hrefMap['174306'], hrefMap['194412']],
};
